import axios from 'axios'; // 引入axios
import router from '../router';
// 使用element-ui Message做消息提醒
import {
	Loading,
	Message
} from 'element-ui';
// import Popup from '../components/login/login.js'

let loading

function startLoading() {
	loading = Loading.service({
		lock: true,
		text: "拼命加载中...",
		background: "rgba(235, 235, 235, 0.1)"
	});
}

function endLoading() {
	loading.close();
}

const service = axios.create({
	// 公共接口--这里注意后面会讲
	// baseURL: process.env.BASE_API,
	// 超时时间 单位是ms，这里设置了3s的超时时间
	timeout: 60 * 1000
})

//请求拦截器
service.interceptors.request.use(config => {
	//发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
	// const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
	// config.data = JSON.parse(config.data);
	// console.log(config.time)
	if (!config.headers_config) {
		config.headers = {
			'Content-Type': 'application/json;charset=utf-8',
			// 'Content-Type': 'application/x-www-form-urlencoded',
			"Admin-Token": sessionStorage.getItem("token-sdk-system"),
			// 'sign':config.sign,
			// 'time':config.time
		}
	} else {
		config.headers = {
			'Content-Type': 'application/json;charset=utf-8',
			// 'Content-Type': 'multipart/form-data',
			"Admin-Token": sessionStorage.getItem("token-sdk-system"),
			// 'sign':config.sign,
			// 'time':config.time
		}
		config.responseType = 'blob'
	}

	// if(token){
	//   config.params = {'token':token}
	// }
	// 请求拦截进来调用显示loading效果
	startLoading()
	// console.log(config.url)
	return config
}, error => {
	// 请求拦截进来调用显示loading效果
	startLoading()
	return Promise.reject(error)
})

//响应拦截器
service.interceptors.response.use(response => {
	//接收到响应数据并成功后的一些共有的处理，关闭loading等
	endLoading()
	if (response && response.data.code) {
		// 1.公共错误处理
		// 2.根据响应码具体处理
		switch (response.data.code) {
			case 212:
				router.push('/') //权限不匹配
				break;
			case 211:
				router.replace('/login') //未登录
				break;
			case 403:
				router.replace('/login') //token过期重新登录
				break;
			case 400:
				response.message = response.data.msg //用户名或密码错误
				break;
			case 500:
				response.message = response.data.msg //服务端错误
				break;
		}
	}
	if (response.message) {
		// 成功后提示
		Message({
			message: response.message,
			center: true,
			type: 'error'
		})
	}
	if(response.data.code == 1){
		
	}
	return response.data
}, error => {
	/***** 接收到异常响应的处理开始 *****/
	endLoading()
	console.log(error)
	//对状态码做即时处理
	if (error && error.response) {
		// 1.公共错误处理
		// 2.根据响应码具体处理
		switch (error.response.status) {
			case 400:
				error.message = '错误请求'
				break;
			case 401:
				error.message = '未授权，请重新登录'
				break;
			case 402:
				error.message = '未授权，请申请授权'
				break;
			case 403:
				error.message = '拒绝访问'
				break;
			case 404:
				error.message = '请求错误,未找到该资源'
				// window.location.href = "/NotFound"
				break;
			case 405:
				error.message = '请求方法未允许'
				break;
			case 408:
				error.message = '请求超时'
				break;
			case 412:
				error.message = '签名校验未通过，请重试'
				break;
			case 500:
				error.message = '服务器端出错'
				break;
			case 501:
				error.message = '网络未实现'
				break;
			case 502:
				error.message = '网络错误'
				break;
			case 503:
				error.message = '服务不可用'
				break;
			case 504:
				error.message = '网络超时'
				break;
			case 505:
				error.message = 'http版本不支持该请求'
				break;
			default:
				error.message = `连接错误${error.response.status}`
		}
		Message.error({
			message: error.message,
			center: true
		})
	} else {
		// 超时处理
		if (error == 'Error: Network Error') {
			Message.error({
				message: '网络异常，请重试',
				center: true
			})
		} else if (JSON.stringify(error).includes('timeout')) {
			Message.error({
				message: '服务器响应超时，请重试',
				center: true
			})
		} else {
			Message.error('连接服务器失败')
		}
		error.message = '连接服务器失败'
		return Promise.resolve(error.message)
	}
	// Message.error(err.message)
	/***** 处理结束 *****/
	//如果不需要错误处理，以上的处理过程都可省略
	// return Promise.resolve(error.response)
	// return Promise.resolve('连接服务器失败')
})


export default service